import styled from 'styled-components';
import { media } from 'utils/detection';

export default styled.div`
  position: relative;
  width: 100%;
  height: 56vw;
  pointer-events: none;
  left: -34px;
  width: calc(100% + 68px);
  margin: 25px 0 0 0;

  ${media.medium`
    width: 35vw;
    height: 20vw;
    left: 0;
    margin: 0;
  `}
`;
